import { Component, h, type FunctionComponent } from 'preact';

/** preact/compat's memo, without pulling the rest of compat into the bundle. */
export function memo<P extends object>(render: FunctionComponent<P>) {
  return class Memo extends Component<P> {
    override shouldComponentUpdate(next: P) {
      const a = this.props as Record<string, unknown>;
      const b = next as Record<string, unknown>;
      const keys = Object.keys(b);
      return keys.length !== Object.keys(a).length || keys.some((k) => a[k] !== b[k]);
    }
    override render(props: P) {
      return h(render, props);
    }
  };
}

